export default "__VITE_ASSET__CiQSmMXc__"